import { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../../../contexts/auth/authContext'
import MobileNavigation from '../../common/mobileNavigation';
import { DataDispatchContext } from '../../../contexts/data/dataContext'
import { clickAnalyticsProfile } from '../../common/util/util'
import { 
  userIconDefault,
  userIconSelected,
  questionIconDefault,
  questionIconSelected,
  signOutIconPath,
  houseIconDefault,
  houseIconSelected
} from '../../common/iconPaths'

export default function ProfileMobileNavigation(
    { acctSelected }: any
  ) {
    const auth: any = useContext(AuthContext)
    const dispatch: any = useContext(DataDispatchContext)
    const [selected, setSelected] = useState(acctSelected);
   

    const handleMenuClick = (event: any) => {
      const id = `${event.currentTarget.id}`.replace('Mobile','')
      setSelected(id)
      dispatch({
        type: 'setAcctSelected',
        acctSelected: id
      })
      clickAnalyticsProfile(id)
      if('signout'===id) {
        auth.signOut()
      }
    }

    const navItemList = [
        {
            id: 'details',
            name: "Your account",
            iconPath: userIconDefault,
            selected: userIconSelected,
            action: handleMenuClick
        },
        {
            id: 'system',
            name: "Your system",
            iconPath: houseIconDefault,
            selected: houseIconSelected,
            action: handleMenuClick
        },
        {
            id: 'help',
            name: "Help & support",
            iconPath: questionIconDefault,
            selected: questionIconSelected,
            action: handleMenuClick
        },
        {
            id: 'signout',
            name: "Sign out",
            iconPath: signOutIconPath,
            selected: signOutIconPath,
            action: handleMenuClick
        }
      ]

    useEffect(() => {
      if( selected !== acctSelected ) {
        setSelected(acctSelected)
      }
    },[selected, acctSelected])

    const itemSelected: any = navItemList.find(item=>item.id===selected)

    return (
      <MobileNavigation 
          navItemList={navItemList.filter((n:any)=>n.id!=='signout')}
          title={"Profile"}
          itemSelected={itemSelected}
          defaultSelected={acctSelected}
          handleMenuClick={handleMenuClick}
      />
    )
}